import type { HomeInitialState } from "./home-initial-state";
import { installInitialHomeAnchorRestore } from "./home-anchor";
import { installSingleOpenFaqAccordion } from "./faq-accordion";
import { installScannerIntentBootstrap } from "./scanner-intent-bootstrap";
import { importWithChunkReload } from "./chunk-reload";

declare global {
  interface Window {
    __SKILLSECURITY_DEFER_APP_MOUNT__?: boolean;
    __SKILLSECURITY_HOME_HYDRATED__?: boolean;
    __SKILLSECURITY_HOME_INITIAL_STATE__?: HomeInitialState;
  }
}

window.__SKILLSECURITY_DEFER_APP_MOUNT__ = true;
installInitialHomeAnchorRestore();

installScannerIntentBootstrap({
  selectors: {
    scanner: "#scanner",
    input: "#scanner textarea",
    submit: "#scanner .primary-action",
    uploadAction: "#scanner .workbench-add-files",
    fileInput: "#scanner .hidden-file-input",
    uploadTargets: "#scanner .workbench-add-files, #scanner .hidden-file-input",
  },
  readState: () => window.__SKILLSECURITY_HOME_INITIAL_STATE__,
  writeState: (state) => {
    window.__SKILLSECURITY_HOME_INITIAL_STATE__ = state;
  },
  isHydrated: () => window.__SKILLSECURITY_HOME_HYDRATED__ === true,
  markHydrated: () => {
    window.__SKILLSECURITY_HOME_HYDRATED__ = true;
  },
  loadMount: async () => {
    const { mountApp } = await importWithChunkReload(() => import("./main"));
    return mountApp;
  },
});

installSingleOpenFaqAccordion({
  summarySelector: ".faq-list summary",
  listSelector: ".faq-list",
});

export {};
